$(document).ready(function() {
  let slidersArr = document.querySelectorAll('.homeSlideshow');

  slidersArr.forEach(slider => {
    $(slider).slick({
      infinite: true,
      dots: true,
      autoplay: slider.dataset.autoPlay,
      arrows: false,
      speed: 2000,
      autoplaySpeed: slider.dataset.playSpeed,
      adaptiveHeight: true,
    });
  });
});
